import { locales } from "@i18n/react";
import { z } from "zod";

export const jwtSchema = z.object({
  accountCreatedAt: z.iso.datetime(),
  bannedReason: z.number().nullable(),
  cityLocationId: z.number().nullable(),
  cohorts: z.number().array(),
  communityIds: z.number().array(),
  consent: z.number().array(),
  device: z.number(),
  email: z.email().nullable(),
  exp: z.number(),
  iat: z.number(),
  id: z.number(),
  isAnonymous: z.boolean(),
  isCoppa: z.boolean(),
  isHerald: z.boolean(),
  isSubscribed: z.boolean(),
  language: z.enum(locales).nullable(),
  lastName: z.string().nullable(),
  name: z.string().nullable(),
  permissions: z.number().array(),
  phone: z.string().nullable(),
  platform: z.string(),
  sessionsCount: z.number(),
  userCreatedAt: z.iso.datetime(),
  userPolicyIds: z.number().array(),
});

export type JWTPayload = z.infer<typeof jwtSchema>;
